import { IAction } from 'models';
import {
  SIMULATE_ADD_PAYMENT_METHOD_FAIL,
  SIMULATE_ADD_PAYMENT_METHOD_START,
  SIMULATE_ADD_PAYMENT_METHOD_SUCCESS,
  SIMULATE_COMPLETE_PAYMENT_FAIL,
  SIMULATE_COMPLETE_PAYMENT_START,
  SIMULATE_COMPLETE_PAYMENT_SUCCESS,
  THREE_DS_TIMEOUT
} from 'redux/constants/3ds';

const initialState = {
  simulate: {
    loadingError: false,
    loadingSuccess: false,
    data: {},
    error: null
  },
  three_ds_timeout: false
};

export type I3DSStore = typeof initialState;

const reducer = (state = initialState, action: IAction<string, any>) => {
  switch (action.type) {
    case SIMULATE_COMPLETE_PAYMENT_START:
    case SIMULATE_ADD_PAYMENT_METHOD_START: {
      const loadingError = Boolean(action.payload.loadingError);
      return {
        ...state,
        simulate: {
          ...state.simulate,
          loadingError,
          loadingSuccess: !loadingError
        }
      };
    }
    case SIMULATE_COMPLETE_PAYMENT_SUCCESS:
    case SIMULATE_ADD_PAYMENT_METHOD_SUCCESS:
      return {
        ...state,
        simulate: {
          ...state.simulate,
          data: action.payload.data,
          loadingError: false,
          loadingSuccess: false,
          error: null
        }
      };
    case SIMULATE_COMPLETE_PAYMENT_FAIL:
    case SIMULATE_ADD_PAYMENT_METHOD_FAIL:
      return {
        ...state,
        simulate: {
          ...state.simulate,
          error: action.payload.error,
          loadingError: false,
          loadingSuccess: false
        }
      };
    case THREE_DS_TIMEOUT: {
      return {
        ...state,
        three_ds_timeout: true
      };
    }
    default:
      return state;
  }
};

export default reducer;
